import MapItem from "./MapItem"

class Schools
{
  // ---------------------------------------------------------------------------------------------------------
	// --	Schools
	// ---------------------------------------------------------------------------------------------------------

  constructor()
  {
    console.log('Schools')

    const _items = []
    const holder = this

    //アイテム生成
    $('.sc-schools__map').find('path').each(function(index){

      const path = $(this)
      const id = path.data().id
      const pref = path.data().pref

      let item = null
      if(id >= _items.length || !_items[id])
      {
        item = new MapItem(id, pref)
        item.on('SELECT', holder.onMapSelect.bind(holder))
        _items[id] = item
      }
      else
      {
        item = _items[id]
      }

      item.add(path)
    })

    //配列保持
    this.items = _items

    //リストをクリックした時
    $('.sc-schools__list-group').each(function(){
      $(this).click(function(){
        holder.onMapSelect(-1)
      })
    })
  }

  onMapSelect(id)
  {
    //マップの選択状態更新
    let len = this.items.length
    for(let i=0; i<len; i++)
    {
      const item = this.items[i]
      item.select(item.id == id)
    }

    //リストを表示
    const holder = this
    $('.sc-schools__list-group').each(function(){

      //リスト
      const list = $(this)

      //選択されてたら表示
      if(list.data().id == id)
      {
        //選択した都道府県の位置情報
        const selectedItem = holder.items[id]
        const bounds = selectedItem.getBounds()

        //マップのサイズ
        const mapW = $('.sc-schools__map').width()

        //リスト表示
        list.css('display', 'block')

        //右に配置
        if(bounds.left + bounds.width/2 < mapW/2)
        {
          list.css('top', bounds.top + bounds.height/2 - list.outerHeight()/2)
          list.css('left', bounds.left + bounds.width + 10)
        }
        //左に配置
        else if(bounds.left + bounds.width/2 >= mapW/2)
        {
          list.css('top', bounds.top + bounds.height/2 - list.outerHeight()/2)
          list.css('left', bounds.left - list.outerWidth() -10)
        }
      }
      //非表示
      else
      {
        list.css('display', 'none')
      }
    })

  }

  // ---------------------------------------------------------------------------------------------------------
}

export default Schools
